import marked from "marked";

export const MarkedDownContent = ({ content }) => {
  return <div dangerouslySetInnerHTML={{ __html: marked(content) }}></div>;
};

export default MarkedDownContent;
